import React, { useState, useEffect } from 'react';
import axios from 'axios';

const initialQuote = {
  text: 'Something',
  author: 'someone',
};

// const i = Math.round(1000 * Math.random());

const Quote = () => {
  const [quote, saveQuote] = useState({ ...initialQuote });

  const [intervalId, setIntervalId] = useState();
  const [indexQuote, setIndexQuote] = useState(0);

  const mirrorQuote = { index: 0, author: 'Mirror', text: `Oh little thing, where have you gone? I've been so lost and I need someone to rely on.` };
  const msMirrorQuote = { index: 1, author: 'Ms. Mirror', text: 'Events can be monotonous and same old, same old. But we can still make a difference from within.' };

  // useEffect(() => {
  //   (async function () {
  //     // const result = await axios.get('https://type.fit/api/quotes');
  //     // const result = await axios.get('https://quotes.rest/qod');
  //     // const qObj = result.data.contents.quotes[0];
  //     // saveQuote({ author: result.data[i].author, text: result.data[i].text });
  //     // saveQuote({ author: qObj.author, text: qObj.quote });
  //   })();

  // }, []);

  useEffect(() => {
    saveQuote(mirrorQuote);
  }, []);


  useEffect(() => {
    const iid = setInterval(() => {
      saveQuote(quote.index == 1 ? mirrorQuote : msMirrorQuote);
      setIndexQuote(1 - indexQuote);
    }, 5000);
    setIntervalId(iid);

    return () => {
      clearInterval(iid);
    }

  }, [quote])


  return (
    <>
      <span className='bg-half-dark font16'>
        {'“'}
        {quote.text}
        {'”'} <br />{' '}
        <span className='font16'>
          {' - '}
          {quote.author == null ? 'Anonymous' : quote.author}
        </span>
      </span>
    </>
  );
};

export default Quote;
